import { render, staticRenderFns } from "./AdminSeason.vue?vue&type=template&id=a36f34e8&scoped=true&"
import script from "./AdminSeason.vue?vue&type=script&lang=js&"
export * from "./AdminSeason.vue?vue&type=script&lang=js&"
import style0 from "./AdminSeason.vue?vue&type=style&index=0&id=a36f34e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36f34e8",
  null
  
)

export default component.exports